import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';

export function Page() {
  return (
    <Fragment>
      <PageLayout.Heading text="Kolla din inkorg!" />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--size-4)' }}>
        <p>
          Vi har skickat ett mejl till den e-postadress du angav. Följ länken i mejlet för att återställa ditt lösenord.
        </p>

        <p>
          Fick du inget mejl? Kontrollera din skräppostmapp eller{' '}
          <Link to="/auth/reset-password/request" underline>
            begär en ny återställningslänk
          </Link>
          .
        </p>
      </div>
    </Fragment>
  );
}
